<template>
  <div class="banner-create">
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="100px">
      <el-form-item label="默认名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入，限8字" maxlength="8" :disabled="!!$route.query.id" />
        <span class="input-remark">保存后不能编辑</span>
      </el-form-item>
      <el-form-item label="自定义名称" prop="customName">
        <el-input  v-model="form.customName" placeholder="请输入，限8字" maxlength="8" />
        <span class="input-remark">展示到小程序的名称</span>
      </el-form-item>
      <el-form-item label="页面位置" prop="location" v-if="form.location!='all'">
        <el-select v-model="form.location" placeholder="请选择">
          <el-option v-for="item in pageLocationList" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="图标" prop="logo">
        <UploadImg @getUploadFile="(file)=>{this.form.logo = file }" :uploadUrl="form.logo" :desc="'建议：上传100*100的jpg、 png的图片'"></UploadImg>
      </el-form-item>
      <el-form-item label="类型" prop="type"  v-if="form.location!='all'">
        <el-radio-group v-model="form.type" @change="typeChange">
          <el-radio label="base">内部链接</el-radio>
          <el-radio label="out">外部链接</el-radio>
          <el-radio label="text">富文本</el-radio>
          <el-radio label="miniprogram">小程序跳转</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="" prop="url" v-if="(form.type=='out'||form.type=='base')&&form.location!='all'">
        <el-input v-model="form.url" placeholder="请输入跳转链接" >
           <template v-if="form.type=='out'" slot="prepend">Https://</template>
        </el-input>
      </el-form-item>
      <el-form-item label="" prop="appId" v-if="form.type=='miniprogram'">
          <el-input v-model="form.appId" placeholder="请输入appid"></el-input>
      </el-form-item>
      <el-form-item label="" prop="url" v-if="form.type=='miniprogram'">
          <el-input v-model="form.url" placeholder="请输入跳转链接"></el-input>
      </el-form-item>
        <el-form-item label="详情" prop="detail"  v-if="form.type=='text'">
        <div style="border: 1px solid #ccc; margin-top: 10px;width: calc(100% - 40px);">
          <!-- 工具栏 -->
          <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
          />

          <!-- 编辑器 -->
          <Editor
            style="height: 600px; overflow-y: hidden;"
            :defaultConfig="editorConfig"
            v-model="form.detail"
            @onCreated="onCreated"
          />
        </div>
      </el-form-item>
      <el-form-item label="状态" prop="enable"  v-if="form.location!='all'">
        <el-radio-group v-model="form.enable">
          <el-radio :label="true">启用</el-radio>
          <el-radio :label="false">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="onBack" class="fun-btn mr20">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="onSubmit" class="fun-btn">确定</el-button>
    </div>
  </div>
</template>

<script>
import UploadImg from '@/components/UploadImg/index'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import editor from '@/mixins/editor'
import {  api_putUpdateConfig,api_getConfigDatil, api_postCreatedConfig } from '@/api/pageConfig'
import { api_postFileUpload } from '@/api/common'
export default {
  name: "SCPageConfigAdd",
  components: {
    UploadImg,
    Editor,
    Toolbar
  },
  mixins: [editor],
  data() {
    return {
      id:null,
      form: {
        url: '',
        appId: '',
        logo: '',
      },
      mallOption: [],
      pageLocationList: [
        {name: '首页金刚区', value: 'first'},
        {name: '我的页面', value: 'me'},
        // {name: '会员码', value: 'pay'},
      ],
      rules: {
        customName: [{ required: true, message: '请输入自定义名称' }],
        logo: [{ required: true, message: '请上传图标' }],
        url: [{ required: true, message: '请输入跳转路径' }],
        appId: [{ required: true, message: '请输入appid' }],
      },
      submitLoading: false
    };
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.getInfo()
    }
  },
  methods: {

    // 点击提交按钮
    onSubmit() {
      if (this.form.detail == "<p><br></p>") {
        this.form.detail = "";
      }
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          let params = {
            ...this.form,
          }
          try {
            if (this.form.logo.size) {
              const { key } = await api_postFileUpload(this.form.logo, 'ConfigLogo')
              params.logo = key
            }
            switch (params.type) {
              case 'out':
              case 'base':
                delete params.detail
                delete params.appId
              break;
              case 'text':
                delete params.url
                delete params.appId
              break;
              case 'miniprogram':
                delete params.detail
              break;
              default:
                break;
            }
             //0禁用，1启用
            params.enable ? params.enable = 1 : params.enable = 0
            params.type == 'out'&& !params.url.startsWith("https://") && params.location!='all'?params.url = 'https://'+params.url:params.url
            console.log('params: ', params);
            this.$route.query.id ? await api_putUpdateConfig({...params, id: this.$route.query.id}) : await api_postCreatedConfig({...params})
            this.$baseMessage('操作成功', 'success')
            this.onBack()
            this.submitLoading = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },
     // 字符串截取
    sliceString(str, prefix) {
      if (str.indexOf(prefix) === 0) {
        return str.slice(prefix.length);
      }
      return str;
    },
    typeChange(){
      this.form.url = ''
      this.form.appId = ''
      this.form.detail = ''
      this.$refs.form.clearValidate();
    },
    // 获取详情数据
    async getInfo () {
      const data = await api_getConfigDatil({id: this.$route.query.id})
      let {name,customName,logo,type,appId,enable,detail,url,location} = data
      enable === 1?enable=true:enable=false
      url = url?this.sliceString(url,'https://'):''
      appId = appId?appId:''
      this.form = {name,customName,logo,type,appId,enable,detail,url,location}
    },
    // 返回
    onBack() {
      this.$router.back(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-create {
  width: 100%;
  padding-top: 20px;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 100px;
  .el-input,
  .el-textarea,
  .el-select {
    width: 350px;
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
    margin-left: 10px;
  }

  .optional {
    height: 17px;
    line-height: 17px;
    margin-top: 5px;
    font-size: 12px;
    color: #666666;
  }
  ::v-deep{
    .avatar-uploader{
      height: 152px;
    }
  }

  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
